/**
 * PrismLog Admin Log Diff Detail Store
 *
 * @since 2018-11-05
 * @author mk.ko
 */

export const state = () => ({
  diffCountData: {},
  diffSummaryData: [],
  diffDetailData: []
})

export const mutations = {
  setAdminLogDiff (state, payload) {
    state.diffCountData = payload.count
    state.diffSummaryData = payload.summary
  },
  setAdminLogDiffDetail (state, payload) {
    state.diffDetailData = payload
  }
}
export const actions = {
  async getAdminLogDiff ({ commit, state }, { auditLogId }) {
    const apiUrl = `/api/lr/prism/log/audit_log/detail/${auditLogId}`

    const { code, result } = await this.$axios.$get(apiUrl, {
      loading: false
    })

    if (code === 'ok') {
      const payload = {}
      const count = {}

      const diffCount = result.diff_cnt

      diffCount.forEach(row => {
        switch (row.audit_log_diff_type) {
          case 1:
            count['add'] = row.cnt
            break
          case 2:
            count['edit'] = row.cnt
            break
          case 3:
            count['delete'] = row.cnt
            break
          default:
            break
        }
      })
      if (!count.hasOwnProperty('add')) { count['add'] = 0 }
      if (!count.hasOwnProperty('edit')) { count['edit'] = 0 }
      if (!count.hasOwnProperty('delete')) { count['delete'] = 0 }

      payload.count = count
      payload.summary = result.diff_summary

      commit('setAdminLogDiff', payload)
    }
  },
  async getAdminLogDiffDetail ({ commit, state }, { auditLogId, auditLogDiffId }) {
    const apiUrl = `/api/lr/prism/log/audit_log/detail/${auditLogId}/diff/${auditLogDiffId}`

    const { code, result } = await this.$axios.$get(apiUrl)

    if (code === 'ok') {
      commit('setAdminLogDiffDetail', result[0])
    }
  }
}

export const getters = {}
export const strict = false
